export { default as images } from './images'
export const headerItem = ['accueil', 'services', 'avis', 'a propos', 'contact']
export const navItem = ['accueil', 'offre', 'services', 'contact']